export default "__VITE_ASSET__ukdIgtES__"